<template>
	<Aspect type="achieve" span=5.5 name="十三个方面成就"/>
</template>
<script>
import Aspect from "./Aspect";
export default {
	name: 'achieve',
	props:{
		active: {
			type: Number,
			default: 1
		}
	},
	components: {
		Aspect
	},
	data() {
		return {}
	},
	created() {
		/* //获取到localStorage里的值
		this.username = localStorage.getItem("username");
		this.userData.groupid = localStorage.getItem("groupid");
		this.userData.userid = localStorage.getItem("userid");
		this.groupid_list = JSON.parse(
			window.localStorage.getItem("groupid_list")
		); */

		//yes网站版 no镜像版
		//web:网页版 mirror:镜像版
		if(this.isWeb=='yes'){
			this.v_type="web";
		}else{
			this.v_type="mirror";
		}

	},
	mounted() {
	},
	methods: {
	},
	computed: {},
};
</script>

<style lang="scss" scoped>
</style>
